import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { eventsAPI } from '../services/api';

const EventDetails = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvent = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await eventsAPI.getEventById(id);
        setEvent(response.data);
      } catch (err) {
        setError('Failed to load event details. Please try again later.');
        console.error('Error fetching event:', err);
      } finally {
        setLoading(false);
      }
    };

    loadEvent();
  }, [id]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
        timeZoneName: 'short',
    });
  };

  if (loading) {
    return <div style={styles.loading}>Loading event details...</div>;
  }

  if (error) {
    return (
      <div style={styles.container}>
        <div style={styles.error}>{error}</div>
        <Link to="/" style={styles.backLink}>← Back to Events</Link>
      </div>
    );
  }

  if (!event) {
    return (
      <div style={styles.container}>
        <div style={styles.error}>Event not found.</div>
        <Link to="/" style={styles.backLink}>← Back to Events</Link>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <Link to="/" style={styles.backLink}>← Back to Events</Link>
      
      <div style={styles.eventDetails}>
	<div style={styles.metaInfo}>                                                                                                                                                                   
            <p><strong>{event.etype}</strong></p>                                                                                                                                                       
        </div>   
        <div style={styles.header}>
          <h1 style={styles.title}>{event.title}</h1>
          <span style={styles.eventType}>{event.event_type}</span>
        </div>

        <div style={styles.content}>
       

          <section style={styles.section}>
            <div style={styles.infoGrid}>
              <div style={styles.infoItem}>
                <strong>Speaker:</strong> {event.speaker.first_name} {event.speaker.last_name}
              </div>
              <div style={styles.infoItem}>
                <strong>Affiliation:</strong> {event.speaker.affiliation}
              </div>
              <div style={styles.infoItem}>
                <strong>Location:</strong> {event.location}
              </div>
              <div style={styles.infoItem}>
                <strong>Start Date & Time:</strong> {formatDate(event.start)}
              </div>
              <div style={styles.infoItem}>
                <strong>End Date & Time:</strong> {formatDate(event.end)}
              </div>
            </div>
          </section>
	    <section style={styles.section}>
		<h3 style={styles.sectionTitle}>Abstract</h3>
		<p style={styles.description}>
		<div dangerouslySetInnerHTML={{ __html: event.description }}/>
		</p>
          </section>
	</div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
  },
  backLink: {
    display: 'inline-block',
    color: '#3498db',
    textDecoration: 'none',
    marginBottom: '2rem',
    fontSize: '1.1rem',
  },
  eventDetails: {
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '2rem',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '2rem',
    borderBottom: '2px solid #eee',
    paddingBottom: '1rem',
  },
  title: {
    color: '#2c3e50',
    margin: 0,
    fontSize: '2rem',
    flex: 1,
  },
  eventType: {
    backgroundColor: '#3498db',
    color: 'white',
    padding: '0.5rem 1rem',
    borderRadius: '25px',
    fontSize: '1rem',
    marginLeft: '1rem',
  },
  content: {
    lineHeight: '1.6',
  },
  section: {
    marginBottom: '2rem',
  },
  sectionTitle: {
    color: '#2c3e50',
    borderBottom: '1px solid #eee',
    paddingBottom: '0.5rem',
    marginBottom: '1rem',
  },
  description: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '1rem',
  },
  infoItem: {
    padding: '0.75rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px',
    border: '1px solid #e9ecef',
  },
  loading: {
    textAlign: 'center',
    padding: '2rem',
    fontSize: '1.2rem',
    color: '#666',
  },
  error: {
    textAlign: 'center',
    padding: '2rem',
    fontSize: '1.2rem',
    color: '#e74c3c',
    backgroundColor: '#fdf2f2',
    border: '1px solid #f5c6cb',
    borderRadius: '4px',
    margin: '1rem 0',
  },
};

export default EventDetails;
